import React from 'react'

const SvgEmail = props => (
    <svg viewBox="50 0 200 200" {...props}>
        <path d="M150 0C94.5 0 50 44.5 50 100s44.5 100 100 100 100-44.5 100-100S205.5 0 150 0zm45 65.5l-45 45-45-45h90zM94.1 73.2l26.8 26.8-26.8 26.8V73.2zm10.9 61.3l25-25 10.9 10.9c5 5 13.2 5 18.6 0l10.9-10.9 25 25H105zm74.5-34.5l26.8-26.8v53.6L179.5 100z" />
    </svg>
)

export default SvgEmail



// WEBPACK FOOTER //
// ./src/ui/icons/Email.js